var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnketBb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5v-11c0-.813-.688-1.5-1.5-1.5h-11A1.5 1.5 0 0 0 0 1.5v11c0 .844.656 1.5 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5Zm-12.5 0v-11h11v11h-11ZM3 3.75v.5c0 .281.219.5.5.5h4c.25 0 .5-.219.5-.5v-.5c0-.25-.25-.5-.5-.5h-4c-.281 0-.5.25-.5.5Zm0 3v.5c0 .281.219.5.5.5h7c.25 0 .5-.219.5-.5v-.5c0-.25-.25-.5-.5-.5h-7c-.281 0-.5.25-.5.5Zm0 3v.5c0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5v-.5c0-.25-.25-.5-.5-.5h-2c-.281 0-.5.25-.5.5Z",
    fill: "#CE0F1D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnketBb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/anket-bb.a17b4ae5c8e197f893e33c536bcf2e37.svg";